// 增值服务
export var BASE_ADD_SERVICE = {
    /** 密钥认证--国内 */
    PASSWORD_AUTH: { fcode: 'IN59', code: '59' },
    /** 尚派服务 */
    LUXURY_DELIVERY: { fcode: 'IN153', code: '153' },
    /**  国际件-密钥认证(与大陆件的口令签收代码一致都是IN59 当前版本: v5.1 日期: 2019-12-02)  */
    SIGN_CONFIRM: { fcode: 'IN59', code: '59' },
    /** 升舱即日 */
    UPGRADE_INTRA_DAY: { fcode: 'IN118', code: 'VA0091' },
    /** 升舱次晨 */
    UPGRADE_NEXT_MORNING: { fcode: 'IN119', code: 'VA0092' },
    /** 高峰管控 */
    FASTIGIUM_CONTROL: { fcode: 'IN100', code: '92' },
    /** 高峰管控 */
    FASTIGIUM_CONTROL_FIVE: { fcode: 'IN104', code: '104' },
    /** 保价 */
    INSURANCE: { fcode: 'IN02', code: '3' },
    /** 特安 */
    SPECIAL_SECURE: { fcode: 'IN21', code: '23' },
    /** 保鲜服务 */
    KEEP_FRESH: { fcode: 'IN41', code: '47', editCode: '3' },
    /** 准时保 */
    ON_TIME_INSURANCE: { fcode: 'IN121', code: '121' },
    /** 定时派送-指定时段 */
    DELIVERY_APPOINT_TIME: { fcode: 'IN26', code: '41' },
    /** 定时派送-待寄方通知 */
    DELIVERY_DEPEND_ON_SENDER: { fcode: 'IN04', code: '7' },
    /** 代收货款 */
    CUSTOM_CARD: { fcode: 'IN01', code: '4' },
    /** 签单返还(纸质回单) */
    SIGN_BACK: { fcode: 'IN03', code: '8' },
    /** 包装服务 */
    PACKAGE_SERVICE: { fcode: 'IN67', code: '67' },
    /** 木质包装 */
    WOOD_PACKAGE: { fcode: 'IN31', code: '39' },
    /** 木架拆卸 */
    WOOD_TEAR_DOWN: { fcode: 'IN152', code: '152' },
    /** 丰巢限时优惠(高效能 下单未实际下发) */
    FC_LIMITED_TIME_OFFER: { fcode: 'IN113' },
    /** 送到柜服务(高效能 下单未实际下发) */
    SEND_TO_FC_BOX: { fcode: 'IN125', code: '125' },
    /** 委托件 */
    DELEGATE: { fcode: 'IN10', code: '19' },
    /** 大件入户 */
    BULKY_CARGO_TO_HOME: { fcode: 'IN98', code: '98' },
    /** 拍照回传 */
    ELECTRONIC_RECEIPT: { fcode: 'IN91', code: '91' },
    /** 送货上楼 */
    GO_UPSTAIRS: { fcode: 'IN45', code: '45' },
    /** 超长超重附加费 */
    LONG_HEAVY: { fcode: 'IN23', code: '48' },
    /** 惊喜送达 */
    SRUPRISE_ARRIVE: { fcode: 'IN150' },
    /** 乡村达 */
    COUNTRY_SIDE_ARRIVE: { fcode: 'IN127', feeCode: '127' },
    /** 特殊入仓 */
    SPECIAL_WAREHOUSING: { fcode: 'IN102', feeCode: '106' },
    /** 电子回单 */
    MICRO_SIGN: { fcode: 'IN149', code: '149' },
    /** 参展服务 */
    EXHIBITION: { fcode: 'IN123' },
    /** 其他服务 */
    OTHER: { fcode: 'IN200' },
    /** 撤展服务 */
    BACKOUT_EXHIBITION: { fcode: 'IN60', feeCode: '60' },
    /** 无忧保 */
    CARE_FERR_INSURANCE: { fcode: 'IN159', feeCode: '159' },
    /** 定额保 */
    SPECIFIED_INSURANCE: { fcode: 'IN160', feeCode: '160' },
    /** 准时宝 + 保价 组合增值服务 */
    ON_TIME_AND_INSURANCE_COMB: { fcode: 'ZH01' },
    /** 秘钥认证 + 保价 组合增值服务 */
    SIGN_CONFIRM_AND_INSURANCE_COMB: { fcode: 'ZH02' },
    /** 定时派送 + 保价 组合增值服务 */
    TIMING_SEND_AND_INSURANCE_COMB: { fcode: 'ZH03' },
    /** 定时派送 + 秘钥认证  组合增值服务 */
    TIMING_SEND_AND_SIGN_CONFIRM_COMB: { fcode: 'ZH04' },
    /** 特殊入仓 os03 （第三方仓库收费 入仓垫付费） */
    SPECIAL_WAREHOUSING_THIRD: { fcode: 'OS03', code: '25' },
    /** 检测报告 */
    EXAMINING_REPORT: { fcode: 'IN155' }
};
// 异常件改派对应serviceCode
export var ABNORMAL_SERVICE_CODE = {
    /* 1 转寄 */
    FORWARD: 1,
    /* 2 退回 */
    RETURN: 2,
    /* 3 催派/优派 */
    URGE_SEND: 3,
    /* 4 要求再派 */
    SEND_AGAIN: 4,
    /* 5 改自取 */
    SELF_PICK_UP: 5,
    /* 6 改派送（上门派件） */
    RELIVERY_HOME: 6,
    /* 7 更改派送时间 */
    DELIVERY_TIME: 7,
    /* 8 更改收方信息 */
    RECIPIENT_INFO: 8,
    /* 9 更改付款方式 */
    PAYMENT_METHOD: 9,
    /* 10 更改代收金额 */
    COLLECTION_AMT: 10,
    /* 12 作废 */
    INVALID: 12,
    /* 13 超范围转寄 */
    OUT_OF_RANGE: 13,
    /* 15 拒收 */
    REJECT: 15,
    /* 16 售后 */
    AFTER_SALE: 16,
    /* 17 补充经纬度 */
    SUPPLE_LAT_LOG: 17,
    /* 21 改自取-中转场 */
    SELF_PICK_UP_TRANSIT: 21,
    /* 22 改自取-网点 */
    SELF_PICK_UP_OUTLETS: 22,
    /* 23 改自取-丰巢柜 */
    SELF_PICK_UP_FC: 23,
    /* 24 改自取-顺丰优选 */
    SELF_PICK_SFBEST: 24,
    /* 25 改自取-便利店 */
    SELF_PICK_STORE: 25,
    /* 27 时效保障 */
    TIME_GUARANTEE: 27,
    /* 28 改上门-指定位置 */
    RELIVERY_LOCATION: 28,
    /* 30 时效升舱 */
    TIME_UPGRADE: 30,
    /* 31 线上拒收 */
    REJECT_ONLINE: 31,
    /* 36 更改付款方式（寄付月结/寄付第三方月结改到付） */
    PAYMENT_METHOD_MONTHLY: 36,
    /** 39 无人车派件预约 */
    UNMANNED_VEHICLE: 39,
    /* 41 目的地升舱 */
    TIME_UPGRADE_DESTINATION: 41,
    /* 48 目的地升舱专车 */
    TIME_UPGRADE_OVERSIZEDUPGRADES: 48,
    /* 42 取消保价 */
    CANCEL_INSURANCE: 42
};
// 网点类型
export var STORE_TYPE = {
    /** 自营服务点 */
    SITE: '1',
    /** 合作商家店 */
    SHOP: '2',
    /** 顺丰优选 */
    YX: '3',
    /** 顺丰站 */
    STATION: '4',
    /** 丰巢 */
    FC: '5',
    /** 智能柜 */
    INTELLIGENT_CABINET: '6',
    /** 显示所有服务点类型 */
    ALL: 'all'
};
// 跳转扫码5.0渠道来源
export var CHANNEL = {
    SFFAPP: 'sfapp',
    WX: 'wx',
    ALIPAY: 'alipay',
    MONTHSETTLEGZH: 'monthsettlegzh',
    HWAPP: 'hwapp',
    QUICKAPP: 'quickapp' // 厂商快应用
};
/** 寄件人、收件人、第三方标识 */
export var ROLE = {
    /** 寄件人 */
    SENDER: '1',
    /** 收件人 */
    RECEIVER: '2',
    /** 第三方 */
    THIRD_PARTY: '3'
};
// 快递员信息
export var EXPRESS_MAN_INFO = {
    NAME: '顺丰快递员',
    TEL: '95338',
    GRADE: 4.9 // 默认评分
};
// 默认客服电话
export var DEFAULT_CUSTOMER_SERVICE_PHONE = '95338';
// 默认异常提示
export var DEFAULT_ERROR_MSG = {
    NETWORK: '网络异常，请稍后再试!',
    SYSTEM: '系统繁忙，请稍后再试！'
};
// 代收货款卡号黑名单
export var CUSTOMER_CODE_BLACK_LIST = [
    '0000000001',
    '0000000003',
    '0214491723',
    '0000000021',
    '0000000019',
    '0000000015',
    '0000000011',
    '0000000033',
    '0000000022',
    '7555025135',
    '5743011275',
    '8526622776',
    '0000000002',
    '5743816931',
    '0000000006',
    '0000000013',
    '0000000012',
    '0000000025',
    '0000000026',
    '0213445734',
    '0650035477'
];
// 上门时间， 默认展示
export var PICK_UP_TIME_LABEL = {
    NORMAL_PICK_UP_TIME_LABEL: '一小时内',
    NORMAL_PICK_UP_TWO_HOUR_LABEL: '两小时内',
    CITYWIDE_PICK_UP_TIME_LABEL: '半小时内'
};
// 不同流向最大声明价值
export var MAX_DECLARE_VALUE_MAP = new Map([
    /** 大陆-大陆-普通寄件 */
    ['CHN_CHN', 500000],
    /** 大陆-港澳台-普通寄件 */
    ['CHN_HKMOTW', 500000],
    /** 大陆-国际-普通寄件 */
    ['CHN_IBU', 20000],
    /** 香港寄出 */
    ['HK', 100000],
    /** 澳门寄出 */
    ['MO', 100000],
    /** 台湾寄出 */
    ['TW', 4000000],
    /** 大陆-大陆-寄大件 */
    ['CHN_CHN_LARGESHIP', 500000],
    /** 大陆-大陆-扫码大件 */
    ['CHN_CHN_SCANLARGESHIP', 500000],
    /** 大陆-大陆-易碎保 */
    ['CHN_CHN_FRAGILE', 500000]
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-constants/dist/esm/common.js
// module id = null
// module chunks = 